import { createClient, EntrySkeletonType } from 'contentful'
import { JsonItem } from 'types/contentful'
import { LOCALES } from '../consts/index'

export type ContentfulDepth = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

const contentfulClient = createClient({
  space: process.env.API_CONTENTFUL_SPACE,
  environment: process.env.CONTENTFUL_ENV,
  accessToken: process.env.API_CONTENTFUL_TOKEN
})

const contentfulClientPreview = createClient({
  space: process.env.API_CONTENTFUL_SPACE,
  environment: process.env.CONTENTFUL_ENV,
  accessToken: process.env.API_CONTENTFUL_PREVIEW_TOKEN,
  host: 'preview.contentful.com'
})

const contentFul = {
  getEntries(json: JsonItem, isPreview: boolean) {
    const client = isPreview ? contentfulClientPreview : contentfulClient
    return client.getEntries<EntrySkeletonType>({
      ...json,
      include: 6,
      locale: LOCALES[process.env.SHOP_LOCALE]
    })
  },

  getEntry(id: string, depth:  ContentfulDepth, isPreview: boolean) {
    const client = isPreview ? contentfulClientPreview : contentfulClient
    return client.getEntry<EntrySkeletonType>(id, {
      locale: LOCALES[process.env.SHOP_LOCALE],
      include: depth
    })
  },

  getAsset(id: string, isPreview: boolean) {
    const client = isPreview ? contentfulClientPreview : contentfulClient

    return client.getAsset(id)
  }
}

export default contentFul
